module.exports = __webpack_public_path__ + "img/veloshop.ca_Quebec1__1551460537_76.67.188.141.5e56d222.jpg";